import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { animate, sequence, style, transition, trigger } from '@angular/animations';
import { LegacyBookInitService } from '../../legacy-bookexpress/services/legacy-book-initializer.service';
import { Permissions } from 'model/shared/backend-api-response/permissions';
import { SharedService } from '../../legacy-bookexpress/services/shared.service';
import { AzureTokenBlobPipe } from 'app/shared/pipes/azureBlobToken.pipe';
import { RGuestMessages } from 'model/shared/backend-api-response/rguest-messages';
import { CpinService } from '../../legacy-bookexpress/services/cpin.service';
import { Router } from '@angular/router';
import { CasinoPlayerService } from '../../legacy-bookexpress/services/casino-player.service';
import { PreloaderService } from '../../legacy-bookexpress/services/preloader.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { LogoutService } from '../../legacy-bookexpress/services/logout.service';
import { ModifyReservationsService } from 'modules/shared/services/modify-reservations.service';
import { ReservationService } from '../../legacy-bookexpress/services/reservation.service';
import { Reservation } from 'model/shared/backend-api-response/reservation';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { BookService } from 'modules/shared/legacy-bookexpress/services/book.service';
import { GUEST_ADDRESS_DETAILS } from 'modules/shared/constant';
import { CommonDataService } from 'modules/group/shared/commonData.service';

@Component({
  selector: 'app-guest-details',
  templateUrl: './guest-details.component.html',
  styleUrls: ['./guest-details.component.scss'],
  animations: [
    trigger('anim', [
      transition('* => void', [
        style({
          height: '*',
          opacity: '1',
          transform: 'translateX(0)',
          'box-shadow': '0 1px 4px 0 rgba(0, 0, 0, 0.3)',
        }),
        sequence([
          animate(
            '.25s ease',
            style({
              height: '*',
              opacity: '.2',
              transform: 'translateX(20px)',
              'box-shadow': 'none',
            })
          ),
          animate(
            '.1s ease',
            style({
              height: '0',
              opacity: 0,
              transform: 'translateX(20px)',
              'box-shadow': 'none',
            })
          ),
        ]),
      ]),
      transition('void => active', [
        style({
          height: '0',
          opacity: '0',
          transform: 'translateX(20px)',
          'box-shadow': 'none',
        }),
        sequence([
          animate(
            '.1s ease',
            style({
              height: '*',
              opacity: '.2',
              transform: 'translateX(20px)',
              'box-shadow': 'none',
            })
          ),
          animate(
            '.35s ease',
            style({
              height: '*',
              opacity: 1,
              transform: 'translateX(0)',
              'box-shadow': '0 1px 4px 0 rgba(0, 0, 0, 0.3)',
            })
          ),
        ]),
      ]),
    ]),
  ],
})
export class GuestDetailsComponent implements OnInit {
  private tenantId: any;
  private propertyId: any;
  rGuestBookMessages: RGuestMessages;
  rGuestBookPermissions: Permissions;
  roomIndex = 0;
  submitted = false;
  roomLists = [];
  newGuest: Array<any> = [];
  private defaultDialCode = '+1|us';
  countryList: any;
  countryCodeKey: any;
  guestDetailsLength: any;
  blockKeyInGuestDetails = false;
  enableKeyInGuestDetails = false;
  doNotPrefillGuestDetails = false;
  disableCapitalizePipe = false;
  marketOptIn: any = {
    optInEmail: false,
    optInCell: false,
    optInMail: false,
  };
  notifyCasinoError = false;
  subscriptions: Subscription[] = [];
  hideDetails = false;
  casinoSecondaryNovalidate = false;
  isCasinoLoggedIn = false;
  casioToken_server_name = '';
  casinoToken_property_name = '';
  AllcasinoValidate = false;
  @ViewChild('iframe') iframe: ElementRef;
  iFrameData: any;
  captureResponse: any;
  isLoading = false;
  reservationData: Reservation;
  @Output() validateFields = new EventEmitter();
  unsubscribe: any;
  parentComponent: any = 'wbe';
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;
  public marketOptInFormValues: any;

  constructor(
    public ConfigService: LegacyBookInitService,
    public _shared: SharedService,
    public azureBlobToken: AzureTokenBlobPipe,
    public CpinService: CpinService,
    public router: Router,
    private CasinoPlayerService: CasinoPlayerService,
    public PreloaderService: PreloaderService,
    public toastr: ToastrService,
    public LogoutService: LogoutService,
    private modifiyResService: ModifyReservationsService,
    public reservationService: ReservationService,
    public bookService: BookService,
    private cdr: ChangeDetectorRef,
    public commonDataService: CommonDataService
  ) {
    this.tenantId = ConfigService.gettenantId();
    this.propertyId = ConfigService.getpropertyId();

    this.reservationData = this.reservationService?.reservationData;
    this.rGuestBookMessages = ConfigService.PropertyData.rGuestMessages;
    this.rGuestBookPermissions = ConfigService.PropertyData.permissions;
    this.guestDetailsLength = ConfigService.PropertyData.guestDetails;

    this.blockKeyInGuestDetails = ConfigService.PropertyData.permissions.functionalPermissions.blockKeyInGuestDetails
      ? ConfigService.PropertyData.permissions.functionalPermissions.blockKeyInGuestDetails
      : this.blockKeyInGuestDetails;
    this.enableKeyInGuestDetails = ConfigService.PropertyData.permissions.functionalPermissions.enableKeyInGuestDetails;
    this.doNotPrefillGuestDetails = ConfigService.PropertyData.permissions.functionalPermissions.doNotPrefillGuestDetails;

    this.disableCapitalizePipe = ConfigService.PropertyData.permissions.functionalPermissions.disableCapitalizePipe;

    this.casioToken_server_name = ConfigService.getcasioToken_server_name();
    this.casinoToken_property_name = ConfigService.PropertyData.PropNameKeyList.validCasino;

    this.subscriptions.push(
      this.CpinService.hideDetails.subscribe((re) => {
        if (re != 'default') {
          this.hideDetails = true;
          window.scrollTo(0, 0);
          $('html').css('overflowY', 'hidden');
        } else {
          this.hideDetails = false;
          $('html').css('overflowY', 'auto');
        }
      })
    );

    this.subscriptions.push(
      this.CasinoPlayerService.validatesecondaryPlayers.subscribe((vs) => {
        if (vs == 'default') {
          this.casinoSecondaryNovalidate = false;
        } else {
          this.casinoSecondaryNovalidate = true;
        }
      })
    );

    this.subscriptions.push(
      this.CpinService.requiredCasinoNumber.subscribe((dt) => {
        if (dt != 'default') {
          this.AllcasinoValidate = true;
          this.CpinService.requiredCasinoNumber.next('default');
        }
      })
    );
    this.unsubscribe = this.reservationService.checkValidateFIelds.subscribe((isValid: boolean) => {
      this.submitted = isValid;
    });
  }

  ngAfterContentInit() {
    this.roomLists = this.modifiyResService.updatedRoom;
    this.updateGuestIndex();
  }

  ngOnInit(): void {
    this._shared
      .getCountryCode(this.azureBlobToken.transform(this.ConfigService.PropertyData.UrlMap.countryCodeUrl))
      .subscribe((countryNames) => {
        this.countryList = countryNames;
        if (this.ConfigService.PropertyData.permissions.functionalPermissions.enableCountryDialInCodeSelection) {
          this.setDefaultDialCode();
          this.setDialCodeForAllGuests();
        }
      });
    this.countryCodeKey = this.ConfigService.PropertyData.countryCodeKey;
  }

  customTrackBy(index: number, obj: any): any {
    return index;
  }

  ngOnDestroy() {
    this.unsubscribe.unsubscribe();
  }

  addNewGuest(roomIndex) {
    this.submitted = false;
    let addressCount = this.roomLists[roomIndex].guestDetails.length;
    this.roomLists[roomIndex].guestDetails[addressCount] = { ...GUEST_ADDRESS_DETAILS };
    this.roomLists[roomIndex].guestDetails[addressCount].id = addressCount;
    this.roomLists[roomIndex].guestDetails[addressCount].countryList = this.countryList;
    this.setDialCode(this.roomLists[roomIndex].guestDetails[addressCount]);
    this.newGuest.push({
      roomIndex: roomIndex,
      guestIndex: addressCount,
    });
    this.updateGuestIndex();
  }

  openClient() {
    if (
      !this.ConfigService.PropertyData.UrlMap.bookHomePageRedirectionUrl ||
      this.ConfigService.PropertyData.UrlMap.bookHomePageRedirectionUrl.toLowerCase() == 'room'
    ) {
      this.router.navigate([
        '/wbe/room/' +
          this.tenantId +
          '/' +
          this.propertyId +
          '/' +
          this.formatDate(new Date(), 0) +
          '/' +
          this.formatDate(new Date(), 1) +
          '/' +
          this.ConfigService.defaultOffer() +
          '/' +
          this.ConfigService.defaultGuestCount,
      ]);
    } else if (this.ConfigService.PropertyData.UrlMap.bookHomePageRedirectionUrl.toLowerCase() == 'offers') {
      this.router.navigate(['/wbe/offers/' + this.tenantId + '/' + this.propertyId]);
    } else if (this.ConfigService.PropertyData.UrlMap.bookHomePageRedirectionUrl.toLowerCase() == 'calendar') {
      this.router.navigate(['/wbe/calendar/' + this.tenantId + '/' + this.propertyId + '/' + this.ConfigService.defaultOffer()]);
    } else if (this.ConfigService.PropertyData.UrlMap.bookHomePageRedirectionUrl.toLowerCase() == 'hotelwebsite') {
      window.location.href = this.ConfigService.PropertyData.UrlMap.CustomerWebsiteUrl;
    }
  }

  formatDate(date, i) {
    let newdate = date;
    if (i == 1) newdate.setDate(newdate.getDate() + 1);
    let dd = newdate.getDate();
    if (dd < 10) {
      dd = '0' + dd;
    }
    let mm = newdate.getMonth() + 1;
    if (mm < 10) {
      mm = '0' + mm;
    }
    let y = newdate.getFullYear();
    return y + '-' + mm + '-' + dd;
  }

  useSameAddress(roomIndex, guestIndex) {
    if (this.roomLists[roomIndex].guestDetails[guestIndex].sameAddress) {
      const iterativeKeys = ['address', 'city', 'state', 'postalCode', 'country'];
      for (let iterativeKey of iterativeKeys) {
        this.roomLists[roomIndex].guestDetails[guestIndex][iterativeKey] = this.roomLists[roomIndex].guestDetails[0][iterativeKey];
      }

      if (this.rGuestBookPermissions.functionalPermissions.maskGuestDetails) {
        this.roomLists[roomIndex].guestDetails[guestIndex].maskedAddress = this.mask(this.roomLists[roomIndex].guestDetails[0].address);
        this.roomLists[roomIndex].guestDetails[guestIndex].maskedCity = this.mask(this.roomLists[roomIndex].guestDetails[0].city);
        this.roomLists[roomIndex].guestDetails[guestIndex].maskedState = this.mask(this.roomLists[roomIndex].guestDetails[0].state);
        this.roomLists[roomIndex].guestDetails[guestIndex].maskedPostalCode = this.mask(
          this.roomLists[roomIndex].guestDetails[0].postalCode
        );
        this.roomLists[roomIndex].guestDetails[guestIndex].maskedCountry = this.mask(this.roomLists[roomIndex].guestDetails[0].country);
      }
    } else {
      this.roomLists[roomIndex].guestDetails[guestIndex].address =
        this.roomLists[roomIndex].guestDetails[guestIndex].city =
        this.roomLists[roomIndex].guestDetails[guestIndex].state =
        this.roomLists[roomIndex].guestDetails[guestIndex].postalCode =
        this.roomLists[roomIndex].guestDetails[guestIndex].country =
          '';
    }
  }

  casinoValidateCheck(roomIndex, i, casinoNo) {
    if (!this.roomLists[roomIndex].guestDetails[i].Authorized) {
      this.notifyCasinoError = true;
    }
  }

  useSameNamesAndAddress(roomIndex, guestIndex) {
    if (this.roomLists[roomIndex].isCasinoOffer == '' || !this.roomLists[roomIndex].isCasinoOffer) {
      if (!this.roomLists[roomIndex].guestDetails[0].sameDetails) {
        this.roomLists[roomIndex].guestDetails[0] = { ...GUEST_ADDRESS_DETAILS };
        this.roomLists[roomIndex].guestDetails[0].id = roomIndex;

        this.setDialCode(this.roomLists[roomIndex].guestDetails[0]);
      } else {
        const iterativeKeys = [
          'title',
          'casinoNo',
          'fName',
          'lName',
          'email',
          'mobile',
          'address',
          'city',
          'state',
          'postalCode',
          'country',
          'sameAddress',
          'isCasinoPlayer',
          'isLoginPlayer',
          'isAddedPlayer',
          'Authorized',
          'empTitle',
          'empFName',
          'empLName',
          'empEmail',
          'empMobile',
          'empAddress',
          'empCity',
          'empPostalCode',
          'empState',
          'empCountry',
          'dialCode',
        ];

        for (let iterativeKey of iterativeKeys) {
          this.roomLists[roomIndex].guestDetails[0][iterativeKey] = this.roomLists[0].guestDetails[0][iterativeKey];
        }

        this.roomLists[roomIndex].guestDetails[0].removeStat = 'active';

        if (this.rGuestBookPermissions.functionalPermissions.maskGuestDetails) {
          this.roomLists[roomIndex].guestDetails[0].maskedEmail = this.mask(this.roomLists[0].guestDetails[0].email);
          this.roomLists[roomIndex].guestDetails[0].maskedMobile = this.mask(this.roomLists[0].guestDetails[0].mobile);
          this.roomLists[roomIndex].guestDetails[0].maskedAddress = this.mask(this.roomLists[0].guestDetails[0].address);
          this.roomLists[roomIndex].guestDetails[0].maskedCity = this.mask(this.roomLists[0].guestDetails[0].city);
          this.roomLists[roomIndex].guestDetails[0].maskedState = this.mask(this.roomLists[0].guestDetails[0].state);
          this.roomLists[roomIndex].guestDetails[0].maskedPostalCode = this.mask(this.roomLists[0].guestDetails[0].postalCode);
          this.roomLists[roomIndex].guestDetails[0].maskedCountry = this.mask(this.roomLists[0].guestDetails[0].country);
        }
      }
      return false;
    }
  }

  mask(s) {
    let result = '';
    for (const char of s) {
      result = result + '*';
    }
    return result;
  }

  removeAddress(roomIndex, guestIndex) {
    if (this.roomLists[roomIndex].guestDetails[guestIndex].casinoNo) {
      let data = {
        casinoNumber: this.roomLists[roomIndex].guestDetails[guestIndex].casinoNo,
        sessionts: new Date().getTime(),
        roomIndex: roomIndex,
        guestIndex: guestIndex,
      };
      this.CpinService.removeCasinoDetails(data);
    }
    //this.roomLists[roomIndex].guestDetails.splice(guestIndex, 1);
    this.roomLists[roomIndex].guestDetails[guestIndex].action = 'DELETE';
    this._shared.updateRoomWithGuestDetails(this.roomLists, this.parentComponent);
    this.updateGuestIndex();
  }

  formFreshGuest(roomIndex, guestIndex) {
    this.roomLists[roomIndex].guestDetails[guestIndex] = { ...GUEST_ADDRESS_DETAILS };
    this.roomLists[roomIndex].guestDetails[guestIndex].dialCode = this.defaultDialCode;
  }

  /**
   * Sets dial code for the given guest information.
   */
  private setDialCode(guestDetails: any): void {
    guestDetails.dialCode = guestDetails.dialCode ? guestDetails.dialCode : this.defaultDialCode;
  }

  private setDialCodeForAllGuests(): void {
    if (this.roomLists) {
      for (const room of this.roomLists) {
        room.guestDetails.forEach((guest: any, index: number) => {
          this.setDialCode(guest);
        });
      }
    }
  }

  /**
   * Sets default dial code from admin portal configuration.
   *
   * @private
   * @memberof BookComponent
   */
  private setDefaultDialCode(): void {
    const dialCode = this.ConfigService.PropertyData.dialCode;
    if (dialCode) {
      const arr = dialCode.split('|');
      this.defaultDialCode = arr.length == 2 ? dialCode : dialCode + '|' + this.getCountryFlag(dialCode);
    } else {
      this.defaultDialCode = '+1|us';
    }
  }

  /**
   * Returns country flag for the given dial code.
   */
  private getCountryFlag(dialCode: string): string {
    const country = this.countryList.find((existingCountry) => existingCountry['dial-code'] === dialCode);
    return country ? country['alpha-2'].toLowerCase() : 'us';
  }

  updateAddress(roomIndex, i) {
    if (roomIndex == 0) {
      for (let count = 1; count < this.roomLists.length; count++) {
        if (this.roomLists[count].guestDetails[i]) {
          if (this.roomLists[count].guestDetails[0].sameDetails) {
            const iterativeKeys = [
              'title',
              'casinoNo',
              'fName',
              'lName',
              'email',
              'mobile',
              'address',
              'city',
              'state',
              'postalCode',
              'country',
              'sameAddress',
              'isCasinoPlayer',
              'isLoginPlayer',
              'isAddedPlayer',
              'empTitle',
              'empFName',
              'empLName',
              'empEmail',
              'empMobile',
              'empAddress',
              'empCity',
              'empPostalCode',
              'empCountry',
              'empState',
              'dialCode',
            ];
            for (let iterativeKey of iterativeKeys) {
              this.roomLists[count].guestDetails[i][iterativeKey] = this.roomLists[0].guestDetails[i][iterativeKey];
            }

            this.roomLists[roomIndex].guestDetails[i].Authorized = this.roomLists[0].guestDetails[i].Authorized;
            this.roomLists[count].guestDetails[i].sameDetails = true;

            if (this.rGuestBookPermissions.functionalPermissions.maskGuestDetails) {
              this.roomLists[count].guestDetails[i].maskedEmail = this.mask(this.roomLists[0].guestDetails[i].email);
              this.roomLists[count].guestDetails[i].maskedMobile = this.mask(this.roomLists[0].guestDetails[i].mobile);
              this.roomLists[count].guestDetails[i].maskedAddress = this.mask(this.roomLists[0].guestDetails[i].address);
              this.roomLists[count].guestDetails[i].maskedCity = this.mask(this.roomLists[0].guestDetails[i].city);
              this.roomLists[count].guestDetails[i].maskedState = this.mask(this.roomLists[0].guestDetails[i].state);
              this.roomLists[count].guestDetails[i].maskedPostalCode = this.mask(this.roomLists[0].guestDetails[i].postalCode);
              this.roomLists[count].guestDetails[i].maskedCountry = this.mask(this.roomLists[0].guestDetails[i].country);
            }
          }
          if (this.roomLists[count].guestDetails[i].sameAddress) {
            const iterativeKeys = ['address', 'city', 'state', 'postalCode', 'country', 'dialCode'];
            for (let iterativeKey of iterativeKeys) {
              this.roomLists[count].guestDetails[i][iterativeKey] = this.roomLists[0].guestDetails[i][iterativeKey];
            }

            if (this.rGuestBookPermissions.functionalPermissions.maskGuestDetails) {
              this.roomLists[count].guestDetails[i].maskedAddress = this.mask(this.roomLists[0].guestDetails[i].address);
              this.roomLists[count].guestDetails[i].maskedCity = this.mask(this.roomLists[0].guestDetails[i].city);
              this.roomLists[count].guestDetails[i].maskedState = this.mask(this.roomLists[0].guestDetails[i].state);
              this.roomLists[count].guestDetails[i].maskedPostalCode = this.mask(this.roomLists[0].guestDetails[i].postalCode);
              this.roomLists[count].guestDetails[i].maskedCountry = this.mask(this.roomLists[0].guestDetails[i].country);
            }
          }
        }
      }
    }
    this._shared.updateRoomWithGuestDetails(this.roomLists, this.parentComponent);
    return false;
  }
  /**
   * Resets mat autocomplete panel to trigger again correctly when
   * user removes country code in input field.
   */
  resetCountryDropDown(country: string): void {
    if (country == '') {
      this.autocompleteTrigger.closePanel();
      this.autocompleteTrigger.openPanel();
    }
    this.cdr.detectChanges();
  }

  getZipCodeDetails(roomIndex, i, event) {
    if (this.rGuestBookPermissions.functionalPermissions.zipCodeDetails && event.target.classList.contains('ng-dirty')) {
      this.roomLists[roomIndex].guestDetails[i].reloadwindow = true;
      this.bookService
        .getZipCodeDetails(this.roomLists[roomIndex].guestDetails[i].postalCode, this.roomLists[roomIndex].guestDetails[i].address)
        .subscribe(
          (res) => {
            if (res['success']) {
              this.roomLists[roomIndex].guestDetails[i].city = res['city']['name'] ? res['city']['name'] : '';

              this.roomLists[roomIndex].guestDetails[i].state = res['state']['name'] ? res['state']['name'] : '';

              // this.roomLists[roomIndex].guestDetails[i].country = res['country']['code'];
              if (res['country']['code']) {
                let x = this.countryList.filter((country) => country['alpha-2'] == res['country']['code']);
                this.roomLists[roomIndex].guestDetails[i].country = this.countryList.filter(
                  (country) => country['alpha-2'] == res['country']['code']
                )[0][this.countryCodeKey];
              } else {
                this.roomLists[roomIndex].guestDetails[i].country = '';
              }
            } else {
              this.roomLists[roomIndex].guestDetails[i].city = '';
              this.roomLists[roomIndex].guestDetails[i].state = '';
              this.roomLists[roomIndex].guestDetails[i].country = '';
            }
            this.roomLists[roomIndex].guestDetails[i].reloadwindow = false;
            this._shared.updateRoomWithGuestDetails(this.roomLists, this.parentComponent);
          },
          (error) => {
            this.roomLists[roomIndex].guestDetails[i].reloadwindow = false;
          }
        );
    }
  }
  public updateMarketingOptIns(marketingOptInKey: string, value: string, guestIndex: number): void {
    if (guestIndex === 0) {
      if (marketingOptInKey === 'email') {
        this.marketOptInFormValues = { email: value };
      } else if (marketingOptInKey === 'mobile') {
        this.marketOptInFormValues = { mobile: value };
      } else if (marketingOptInKey === 'address') {
        this.marketOptInFormValues = { address: value };
      }
    }
  }
  updateGuestIndex() {
    this.roomLists.forEach((room) => {
      let guestIndex = 1;
      room.guestDetails.forEach((guest) => {
        if (guest.action !== 'DELETE') {
          guest.guestSerialno = guestIndex;
          guestIndex++;
        }
      });
    });
  }
  /**
   * Updates dial code when user selects from drop down.
   */
  public updateDialCode(country: any, guest: any): void {
    guest.dialCode = country['dial-code']?.split('|')[0];
  }
  /**
   * Updates country value on blur event.
   */
  updateCountry(event: any, guestInfo: any): void {
    guestInfo.country = event.target.value;
  }
}
